export default __webpack_public_path__ + "static/media/a7.327b7aff.png";